export interface ExpertProfile {
  id: string
  slug: string
  name: string
  role: string
  subheadline: string
  gmc: string
  qualifications: string
  experience: string
  nhsPost: string
  instructionRatio: string
  reportsCompleted: string
  turnaround: string
  compliance: string
  clinicalFocus: string
  medicoLegalExpertise: string
  keySpecialisms: string[]
  clinicalExpertise: string[]
  medicoLegalTraining: string[]
  caseTypes: string[]
  bio: string
  image: string
}

export const experts: ExpertProfile[] = [
  {
    id: '1',
    slug: 'psychiatrist-ptsd-expert-witness',
    name: 'Dr. Sarah Mitchell',
    role: 'Consultant Psychiatrist',
    subheadline: 'Specialist in PTSD, Trauma, and Capacity Assessments',
    gmc: '4567890',
    qualifications: 'MBChB, MRCPsych, MD',
    experience: '18 years',
    nhsPost: 'South London & Maudsley NHS Foundation Trust',
    instructionRatio: '70% Claimant / 30% Defendant',
    reportsCompleted: '2,500+',
    turnaround: '2–4 weeks (Remote and Face-to-Face assessments available)',
    compliance:
      'Section 12(2) Approved; Extensive experience in Crown and Civil Court evidence',
    clinicalFocus:
      'General Adult Psychiatry, Complex Trauma, and Personality Disorders.',
    medicoLegalExpertise:
      'Psychiatric injury following RTA or workplace trauma, Clinical Negligence (Secondary Victim claims), and Fitness to Plead.',
    keySpecialisms: [
      'PTSD & Trauma',
      'Capacity Assessments',
      'Psychiatric Injury',
    ],
    clinicalExpertise: [
      'Post-Traumatic Stress Disorder (PTSD)',
      'Complex Trauma and Dissociation',
      'Mental Capacity Assessments',
      'Depression and Anxiety Disorders',
      'Personality Disorders',
      'Fitness to Plead Assessments',
    ],
    medicoLegalTraining: [
      'Bond Solon Expert Witness Training',
      'Cardiff University Diploma in Medical Law',
      'Expert Witness Institute Member',
      'Annual CPR Part 35 Updates',
    ],
    caseTypes: [
      'Personal Injury',
      'Clinical Negligence',
      'Family Court',
      'Criminal Cases',
    ],
    bio: 'Dr Mitchell is a Consultant Psychiatrist with 18 years of clinical and medico-legal experience. She specialises in trauma-related psychiatric conditions, particularly PTSD following road traffic accidents and workplace incidents. Dr Mitchell has completed over 2,500 medico-legal assessments and provided expert testimony in more than 500 cases. She is Section 12(2) Approved and has extensive experience in both Crown and Civil Court proceedings. Her reports are known for their clarity, thoroughness, and ability to withstand rigorous cross-examination. She maintains an active NHS practice, ensuring her clinical skills remain current and her opinions grounded in real-world psychiatric practice.',
    image:
      'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=400&h=400&fit=crop&crop=faces&q=75',
  },
  {
    id: '2',
    slug: 'ent-hearing-loss-expert-witness',
    name: 'Mr. James Patterson',
    role: 'Consultant ENT & Head and Neck Surgeon',
    subheadline:
      'Expert in Noise-Induced Hearing Loss (NIHL) & Surgical Negligence',
    gmc: '3456789',
    qualifications: 'MBBS, FRCS (ORL-HNS)',
    experience: '15 years',
    nhsPost: "Guy's and St Thomas' NHS Foundation Trust",
    instructionRatio: '50% Claimant / 40% Defendant / 10% SJE',
    reportsCompleted: '2,000+',
    turnaround: '2–4 weeks',
    compliance:
      'GMC Registered; Experienced in attending Case Conferences and Court cross-examination',
    clinicalFocus:
      'Otology (Hearing/Balance), Tinnitus, Rhinology, and Head/Neck Oncology.',
    medicoLegalExpertise:
      'Occupational Deafness, Industrial Disease, and complications from Sinus/Tonsil surgery.',
    keySpecialisms: [
      'Noise-Induced Hearing Loss',
      'Tinnitus',
      'Surgical Negligence',
    ],
    clinicalExpertise: [
      'Noise-Induced Hearing Loss (NIHL)',
      'Occupational Deafness',
      'Tinnitus Assessment and Prognosis',
      'Vestibular Disorders and Vertigo',
      'Rhinology and Sinus Surgery Complications',
      'Head and Neck Oncology',
    ],
    medicoLegalTraining: [
      'Bond Solon Excellence in Report Writing',
      'Bond Solon Courtroom Skills',
      'Specialist NIHL Assessment Certification',
    ],
    caseTypes: ['Industrial Disease', 'Personal Injury', 'Clinical Negligence'],
    bio: 'Mr Patterson is a Consultant ENT & Head and Neck Surgeon and recognised authority on occupational hearing loss. With over 15 years of medico-legal experience, he has completed more than 2,000 expert reports for industrial disease claims, particularly noise-induced hearing loss (NIHL) and tinnitus. He regularly provides expert witness testimony in high-value claims and is experienced in joint expert discussions and court cross-examination. He is known for his meticulous approach to causation analysis and his ability to explain complex audiological concepts in accessible language for legal professionals.',
    image:
      'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=400&h=400&fit=crop&crop=faces&q=75',
  },
  {
    id: '3',
    slug: 'gp-delayed-diagnosis-expert-witness',
    name: 'Dr. Emily Roberts',
    role: 'Principal General Practitioner',
    subheadline: 'Expert in Primary Care Governance & Delayed Diagnosis',
    gmc: '5678901',
    qualifications: 'MBChB, MRCGP, FRCGP, Dip IMC RCS Ed',
    experience: '12 years',
    nhsPost: 'Manchester University NHS Foundation Trust',
    instructionRatio: '50% Claimant / 50% Defendant',
    reportsCompleted: '3,500+',
    turnaround: '7–18 days',
    compliance:
      'FRCGP; Expert in evaluating "Reasonably Competent GP" standards',
    clinicalFocus:
      'Holistic family medicine, chronic disease management, and emergency primary care.',
    medicoLegalExpertise:
      'Breach of Duty in General Practice, failure to refer, medication errors, and delayed diagnosis of cancer.',
    keySpecialisms: [
      'Delayed Diagnosis',
      'Breach of Duty',
      'Primary Care Governance',
    ],
    clinicalExpertise: [
      'Holistic Family Medicine',
      'Chronic Disease Management',
      'Emergency Primary Care',
      'Delayed Diagnosis of Cancer',
      'Medication Errors and Prescribing',
      'Failure to Refer and Investigate',
    ],
    medicoLegalTraining: [
      'MedCo Accredited Expert',
      'Bond Solon Report Writing',
      'Advanced Trauma Life Support (ATLS)',
      'FRCGP — "Reasonably Competent GP" Standards',
    ],
    caseTypes: [
      'Clinical Negligence',
      'Personal Injury (RTA)',
      'Workplace Accidents',
      'Public Liability',
    ],
    bio: 'Dr Roberts is a Principal General Practitioner and Fellow of the Royal College of General Practitioners with 12 years of medico-legal experience. She has completed over 3,500 medico-legal assessments, specialising in breach of duty in general practice, failure to refer, medication errors, and delayed diagnosis of cancer. Dr Roberts is recognised as an expert in evaluating "Reasonably Competent GP" standards and is regularly instructed in complex clinical negligence claims. Her reports are clear, concise, and focused on the key medico-legal issues. She maintains a busy NHS general practice, ensuring her clinical knowledge remains current across a broad range of medical conditions.',
    image:
      'https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=400&h=400&fit=crop&crop=faces&q=75',
  },
  {
    id: '4',
    slug: 'orthopaedic-surgeon-expert-witness',
    name: 'Mr. David Chen',
    role: 'Consultant Trauma & Orthopaedic Surgeon',
    subheadline:
      'Specialist in Musculoskeletal Trauma & Upper/Lower Limb Arthroplasty',
    gmc: '2345678',
    qualifications: 'MBBS, FRCS (Tr & Orth)',
    experience: '20 years',
    nhsPost: 'Royal National Orthopaedic Hospital',
    instructionRatio: '60% Claimant / 30% Defendant / 10% SJE',
    reportsCompleted: '1,500+',
    turnaround: '2 weeks from receipt of records/examination',
    compliance: 'Fully CPR Part 35 compliant; Bond Solon trained',
    clinicalFocus:
      'Complex fracture management, joint replacement complications, and soft tissue injuries.',
    medicoLegalExpertise:
      'Personal Injury (Condition & Prognosis) and Clinical Negligence (Liability & Causation).',
    keySpecialisms: ['Complex Fractures', 'Spinal Injuries', 'CRPS'],
    clinicalExpertise: [
      'Complex Musculoskeletal Trauma',
      'Spinal Injuries and Surgery',
      'Joint Replacement Complications',
      'Complex Regional Pain Syndrome (CRPS)',
      'Long-term Disability Assessment',
      'Soft Tissue Injuries',
    ],
    medicoLegalTraining: [
      'Cardiff University Bond Solon (CUBS) Civil Certificate',
      'Expert Witness Institute Member',
      'Specialist Clinical Negligence Training',
      'Annual CPR Part 35 Updates',
    ],
    caseTypes: [
      'Personal Injury',
      'Clinical Negligence',
      'Industrial Accidents',
    ],
    bio: 'Mr Chen is a Consultant Trauma & Orthopaedic Surgeon with 20 years of medico-legal experience, specialising in complex musculoskeletal trauma, spinal injuries, and upper/lower limb arthroplasty. He is regularly instructed in high-value catastrophic injury cases and clinical negligence claims involving orthopaedic surgery. Mr Chen has particular expertise in Complex Regional Pain Syndrome (CRPS), joint replacement complications, and long-term disability assessment. He has provided expert testimony in numerous High Court cases and is experienced in multi-disciplinary case conferences. Fully CPR Part 35 compliant and Bond Solon trained, his reports are comprehensive, evidence-based, and provide detailed causation analysis.',
    image:
      'https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=400&h=400&fit=crop&crop=faces&q=75',
  },
]
